import { cn } from "@/utils/helpers/utils"
import Link from "next/link"
import Button, { buttonVariants } from "../Button"
import OptimizedImage from "../Image/OptimizedImage"
import { AUTH_LINKS } from "@/lib/navigation-links"

const content = {
   title: "Become a member of the Restaurant Association!",
   details: "Unlock exclusive access to webinars, events, and the latest news for FREE! ",
}

function NewsletterFull() {
   return (
      <div className="mx-auto grid max-w-[65rem] grid-cols-3 items-center gap-8 bg-[#f5f5fa]">
         <div className="col-span-3 flex flex-col gap-4 rounded-md  bg-[#f5f5fa]  px-4  py-4 text-[#323239] sm:col-span-2 sm:px-16 lg:py-8">
            <h3 className="bg-[#f5f5fa] text-2xl font-semibold leading-[1.2] before:block before:w-[80px] before:border-t-4 before:border-orange-500 before:pb-3 before:content-[''] lg:text-[2.125rem]">
               {content.title}
            </h3>
            <p className="bg-[#f5f5fa] text-base lg:text-xl">{content.details}</p>

            <Link
               href={AUTH_LINKS.signup.href}
               className={cn(
                  buttonVariants({
                     className: " w-full  max-w-[300px] rounded-lg  border-0 bg-orange-500 text-white",
                     variant: "primary",
                     size: "xl",
                     pill: false,
                  }),
               )}
            >
               Sign up
            </Link>
         </div>
         <div className="relative mr-12 hidden aspect-square w-28 bg-[#f5f5fa] sm:col-span-1 sm:inline-block">
            <OptimizedImage
               src={"/_logos/logo-restaurant-association-icon-only-color.webp"}
               sizes="10vw"
               quality={100}
               alt="Restaurant Association Logo"
               fill
            />
         </div>
      </div>
   )
}

export default NewsletterFull

export function NewsletterBorderedMini({ className, customButton }: { className?: string; customButton?: boolean }) {
   return (
      <div className="mx-auto grid max-w-[65rem] grid-cols-3 gap-8 ">
         <div
            className={cn("col-span-3 flex flex-col gap-4 rounded-md  px-4  py-4  text-[#323239] lg:py-8 ", className)}
         >
            <h3 className="text-2xl font-semibold leading-[1.2] before:block before:w-[80px] before:border-t-4 before:border-orange-500 before:pb-3 before:content-[''] lg:text-[1.625rem]">
               {content.title}
            </h3>
            <Link href={AUTH_LINKS.signup.href}>
               {!customButton ? (
                  <Button className=" w-full  rounded-lg border-0    bg-orange-500 text-white" variant="primary">
                     Sign up
                  </Button>
               ) : (
                  <Button className=" w-full  rounded-lg border-0    bg-green-600 text-white ">Sign up</Button>
               )}
            </Link>
         </div>
      </div>
   )
}
